var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 10,
    fill: "url(#paint0_linear_3_12347)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8883 16.1912C25.9733 15.9195 26.0198 15.6373 26.0265 15.3528V11.4074C26.0265 8.59625 21.7834 6.47559 16.1588 6.47559C10.5343 6.47559 6.29117 8.59625 6.29117 11.4074V15.3528C6.34556 16.0099 6.56845 16.6419 6.93833 17.1879C7.30821 17.7338 7.8126 18.1753 8.40285 18.4697C8.31224 18.7366 8.26559 19.0164 8.2647 19.2982V23.2436C8.2647 26.0547 12.5078 28.1754 18.1324 28.1754C23.7569 28.1754 28 26.0547 28 23.2436V19.2982C27.9468 18.642 27.7243 18.0108 27.3542 17.4663C26.9841 16.9217 26.479 16.4824 25.8883 16.1912ZM16.1588 20.2846C19.9579 20.2846 23.1254 19.2982 24.7832 17.8187C25.5726 18.2921 26.0265 18.805 26.0265 19.2982C26.0265 20.5016 22.9478 22.2573 18.1324 22.2573C13.3169 22.2573 10.327 20.5509 10.2382 19.3475C12.1432 19.9976 14.1461 20.3146 16.1588 20.2846ZM16.1588 8.4483C20.9742 8.4483 24.0529 10.204 24.0529 11.4074C24.0529 12.6107 20.9742 14.3664 16.1588 14.3664C11.3434 14.3664 8.2647 12.6107 8.2647 11.4074C8.2647 10.204 11.3434 8.4483 16.1588 8.4483ZM8.2647 14.4256C10.6647 15.7903 13.4 16.4534 16.1588 16.3391C18.9176 16.4534 21.653 15.7903 24.0529 14.4256V15.3528C24.0529 16.5561 20.9742 18.3119 16.1588 18.3119C11.3434 18.3119 8.2647 16.5561 8.2647 15.3528V14.4256ZM18.1324 26.2027C13.3169 26.2027 10.2382 24.447 10.2382 23.2436V22.3165C12.6382 23.6811 15.3736 24.3442 18.1324 24.23C20.8911 24.3442 23.6265 23.6811 26.0265 22.3165V23.2436C26.0265 24.447 22.9478 26.2027 18.1324 26.2027Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_12347",
    x1: 16.3083,
    y1: -13.0216,
    x2: 19.3464,
    y2: 119.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.b8ed51cbb8e94d3d3e6abaf2ccd30cf4.svg";
export { ForwardRef as ReactComponent };